function Footer() {
	const startYear = 2024;
	const currentYear = new Date().getFullYear();
	const displayYear = startYear === currentYear ? `${startYear}` : `${startYear}–${currentYear}`;
	return (
		<footer data-section="footer" className="flex justify-center opacity-80 m-4 mx-auto mt-16 mb-10 md:pl-0 min-[375px]:pl-4 w-full md:max-w-2xl lg:max-w-4xl container">
			<div className="w-full max-w-screen-xl py-4 mx-auto rounded-lg md:flex md:justify-between md:items-center">
				<span className="text-sm color-text-primary sm:text-center dark:color-accent-secondary color">
					© {displayYear} <a href="#" className="hover:underline">carlosdelviento.dev</a>. All rights reserved. Developed by Carlos Barbieri.</span>
				<ul className="flex flex-wrap items-center mt-3 text-sm font-medium sm:mt-0 dark:text-white/90">
					<li>
						<a href="#about" className="hover:underline me-4 md:me-6">About me</a>
					</li>
					<li>
						<a id="contact" href="mailto:carlosdelviento23@gmail.com" className="hover:underline">Contact</a>
					</li>
				</ul>
		</div>
		</footer>
	);
}

export default Footer;
